import { ClientPortalAvailableDefaultLanguageEnum } from '../../../../../shared/models';
import yup from '../../../../../utils/yup-extended';

export const analysisResultsLanguageSchema = yup
  .array(
    yup.mixed().oneOf(Object.values(ClientPortalAvailableDefaultLanguageEnum)),
  )
  .nullable()
  .default(null);
